import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import { memberPortal } from "../member-portal";

export class memberExtendMiles {
	private extForm:any   = $('#miles-expiring-form');
	private memberBase:any = new memberPortal();

	/**
	 * initialize all form inputs with focus and filled effects
	 * find all instances of text inputs in all 3 forms on page
	 * combine them into an array and apply effect to all fields
	 * @return {any} [description]
	 */
	initTextInputs(): any {
		let _self = this;
		let inputElArr:any   = $.makeArray(_self.extForm.find('input[type="text"]'));

		_self.memberBase.initFormTextInputs(inputElArr);
	}

	/**
	 * [initRangeInput description]
	 * @return {any} [description]
	 */
	initRangeInput(): any {
		let _self = this;
		let inputElArr:any   = $.makeArray(_self.extForm.find('input[type="range"]'));

		_self.memberBase.initRangeInput(inputElArr);
	}

	/**
	 * live calculate miles table amount
	 * @return {any} [description]
	 */
	initSummaryTable(): any {
		let _self = this;

		let miles:any         = _self.extForm.find('#miles-to-extend');
		let milesTable:any    = _self.extForm.find('#miles-extension-summary-table');
		let rangeInput:any    = _self.extForm.find('#miles-to-extend-slider');
		let milesTotalCostInput:any = _self.extForm.find('#miles-to-extend-total-cost');

		let mtte:any              = milesTable.find('#m-t-e-miles-amount');

		let mtteMilesUnitCost:number = parseFloat(milesTable.find('#m-t-e-miles-unitcost')[0].innerHTML);
		let mtteMilesSubtotal:any = milesTable.find('#m-t-e-miles-subtotal');

		let mtteAdminUnitCost:number = parseFloat(milesTable.find('#m-t-e-admin-unitcost')[0].innerHTML);

		let mtteGrandTotal:any    = milesTable.find('#m-t-e-grandtotal');

		miles.on('change', (e:any) => {
			let amt:number = parseFloat(rangeInput.val());

			// set table value for (miles to extend)
			mtte.html(amt);

			// calculate cost of miles
			let milesSubtotal:number      = amt * mtteMilesUnitCost;
			let milesSubtotalPrint:string = (Math.round(milesSubtotal * 100) / 100).toFixed(2);
			mtteMilesSubtotal.html(milesSubtotalPrint);

			// calculate total cost (incl admin fee)
			let grandTotal:number      = 0;

			if (milesSubtotal > 0) {
				grandTotal = milesSubtotal + mtteAdminUnitCost
			}

			let grandTotalPrint:string = (Math.round(grandTotal * 100) / 100).toFixed(2);
			mtteGrandTotal.html(grandTotalPrint);
			milesTotalCostInput.val(grandTotal);
		});
	}

	initPageInputs(): any {
		let _self = this;
		let milesTable = $('.miles-expiring-table');

		let milesExpThisYear:number = parseInt(milesTable.find('#miles-expiring-this-year')[0].dataset.value);
		let miles:any               = _self.extForm.find('#miles-to-extend');
		let rangeInput:any          = _self.extForm.find('#miles-to-extend-slider');

		// fill miles value at start
		rangeInput.val(milesExpThisYear);
		rangeInput.rangeslider('update', true);

		miles.parent().find('label').addClass('input-filled');
		miles.addClass('input-filled input-focused');
		miles.val(milesExpThisYear);
		miles.trigger('change');
	}

	initTables(): any {
		let _self = this;

		let extendMilesTable = $('.miles-expiring-table table');
		_self.memberBase.initTables(extendMilesTable);
	}
}

let scope:Element = document.querySelector('#miles-expiring-form');
if (scope) {

	try {
	let memberextendmiles = new memberExtendMiles();
	// memberextendmiles.initTextInputs();
	// memberextendmiles.initRangeInput();
	// memberextendmiles.initSummaryTable();
	// memberextendmiles.initPageInputs();
	memberextendmiles.initTables();
	} catch(e) {console.error(e);}
}
